const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchGarmentTypes = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/garment-type/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener tipos de prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchGarmentTypes:', error);
    throw error;
  }
};

export const fetchGarmentTypesByEdificioId = async (edificioId) => {
  try {
    const response = await fetch(`${API_URL}/garment-type/by-edificio/${edificioId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener tipos de prenda del edificio');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchGarmentTypesByEdificioId:', error);
    throw error;
  }
};

export const createGarmentType = async (data) => {
  try {
    const response = await fetch(`${API_URL}/garment-type`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error al crear tipo de prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en createGarmentType:', error);
    throw error;
  }
};

export const updateGarmentType = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/garment-type/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error al actualizar tipo de prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en updateGarmentType:', error);
    throw error;
  }
};

export const deleteGarmentType = async (id) => {
  try {
    const response = await fetch(`${API_URL}/garment-type/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar tipo de prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en deleteGarmentType:', error);
    throw error;
  }
};
